import React from 'react' 
import { Routes, Route, Navigate } from 'react-router-dom';
// components 
import Modal from '../../screens/Modal'
import Login from '../../screens/Login'
// context 

// ruta PublicSharp, soilo se puede acceder al login 
// public Route, only login is allowed 
export const RouterPublic = () => {
    return (
      <Routes>
        <Route path="/login" exact element={<Login />}/>
        <Route path="/*" element={<Navigate replace to="login" exact />} />
      </Routes>
    );
  };
  
// ruta privada, solo disponible si el usuario esta autenticado 
// private route, only allowed if the user is authenticated 
  export const RouterPrivate = () => {
    return (
      <Routes>
        <Route path="/home" exact element={<Modal />} />
        <Route path="/*" element={<Navigate replace to="home" exact />} />
      </Routes>
    );
  };